import DataErrorImg from './data-error.webp';
import NoDataImg from './img_data_cancel.webp';

export { DataErrorImg, NoDataImg };
